import { rootApi } from 'root-api'

export const PAGE_SIZE = 20

const api = rootApi.injectEndpoints({
  endpoints: (build) => ({
    fetchBookingVerificationSettings: build.query({
      query: ({ userId, scope, page, filterTerm, hostIds, ownerIds, permission, sortField, sortOrder }) => ({
        url: `/api/users/${userId}/booking_verification_settings`,
        method: 'GET',
        params: {
          scope,
          page,
          filter_term: filterTerm,
          host_ids: hostIds,
          owner_ids: ownerIds,
          permission,
          event_types_per_profile: {
            initial: PAGE_SIZE,
            next: PAGE_SIZE
          },
          event_types_order: {
            field: sortField,
            order: sortOrder
          }
        }
      }),
    }),
    createBookingVerificationSettings: build.mutation({
      query: ({ userId, eventTypeUuids, eventTypeIds }) => ({
        url: `/api/users/${userId}/booking_verification_settings`,
        method: 'POST',
        data: {
          event_type_uuids: eventTypeUuids,
          event_type_ids: eventTypeIds
        }
      })
    }),
    deleteBookingVerificationSettings: build.mutation({
      query: ({ userId, eventTypeUuids, eventTypeIds }) => ({
        url: `/api/users/${userId}/booking_verification_settings/batch_destroy`,
        method: 'DELETE',
        data: {
          event_type_uuids: eventTypeUuids,
          event_type_ids: eventTypeIds
        }
      }),
    })
  })
})

export const {
  useFetchBookingVerificationSettingsQuery,
  useCreateBookingVerificationSettingsMutation,
  useDeleteBookingVerificationSettingsMutation
} = api
